var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter_icon",
    "data-name": "Filter icon",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M10.49,17.986a3.246,3.246,0,0,0,.375-.075.894.894,0,0,0,.375-.674v-6.52l6.6-9.518a.8.8,0,0,0,.075-.824A.787.787,0,0,0,17.235,0H.747A.787.787,0,0,0,.073.375a.689.689,0,0,0,.075.749l6.6,9.593v5.021a.72.72,0,0,0,.45.674l3,1.5C10.265,17.986,10.34,17.986,10.49,17.986ZM15.811,1.5,9.89,10.042a1.065,1.065,0,0,0-.15.45v5.546l-1.5-.749v-4.8a1.065,1.065,0,0,0-.15-.45L2.171,1.5Z",
    transform: "translate(1865.009 96)",
    fill: "#474b4f",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.5a93cbe0c5974d540a37762f92946ada.svg";
export { ForwardRef as ReactComponent };